import React, { useState } from 'react';
import FreeTrial from '../../Components/about-page/free-trial';
import { Footer } from '../../Components/Footer';
import HeroContainer from '../../Components/ui/hero-container';
import Button from '../../Components/ui/button/Button';
import FeatureInfoCard from '../../Components/FeatureInfoCard';
import { AcademicTutoringData } from './data/AcademicTutorData';
import HeaderAlt from '../../Components/HeaderAlt';
import CustomModal from '../../Components/CustomModal';
import SignUpPopup from '../tutor-details/components/SignupPopup';

const AcademicTutoring = () => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  return (
    <>
      <HeaderAlt />
      <div className="flex-container relative">
        <HeroContainer className="flex pb-[60px] pt-14 md:pb-[118px]">
          <div className="container flex flex-col gap-6 !px-6 md:flex-row md:justify-between md:gap-20">
            <div className="max-w-[574px] space-y-4 !pt-2 text-left md:space-y-6">
              <p className="!mb-4 text-center text-base font-medium uppercase tracking-[1.28px] text-[#66CDCC] md:text-left">
                Academic Tutoring
              </p>
              <h1 className="fredokaOne w-full text-center text-[40px] font-normal  leading-tight tracking-[-0.8px] text-white md:text-left md:!text-[56px] md:tracking-[-1.12px]">
                Master Any Subject with Top Tutors & AI-Powered Learning
              </h1>
              <p className="fredoka max-w-2xl text-center text-[18px] font-medium leading-[144.44%] tracking-[-0.18px] text-[#678285] md:text-left md:text-[22px] md:leading-[32px] md:tracking-[-0.22px]">
                Get 1:1 tutoring, personalized study guides, and AI-powered practice tests to
                improve performance and stay ahead.
              </p>
              <div className="w-full pt-2 md:w-fit">
                <Button onClick={() => setShowSignupModal(true)} label={'Get Started'} />
              </div>
            </div>
            <div className="mt-6 flex-1 md:mt-0">
              <img
                src="/images/academic-tutoring/academic-hero.png"
                alt="hero-img"
                className="block"
              />
            </div>
          </div>
        </HeroContainer>
        <div className=" mx-auto mt-8 flex max-w-[606px] flex-col gap-4 px-4 text-center md:mt-16 md:px-0">
          <h1 className="fredokaOne w-full text-center text-[32px] font-normal  leading-tight tracking-[-0.8px] text-[#012E33] md:!text-[40px] md:tracking-[-1.12px]">
            Revolutionize Learning with AI Powered Features
          </h1>
          <p className="fredoka max-w-2xl text-center text-[18px] font-medium leading-[144.44%] tracking-[-0.18px] text-[#678285] md:text-[22px] md:leading-[32px] md:tracking-[-0.22px]">
            AI-powered Class Spaces help your child stay organized, focused, and on track with
            personalized learning, setting them up for academic success.
          </p>
        </div>
        <div className="container !mt-5 flex flex-col gap-4  md:!mt-10 ">
          {AcademicTutoringData.map((data, index) => (
            <FeatureInfoCard key={index} data={data} />
          ))}
        </div>

        <div className="container !my-14">
          <FreeTrial />
        </div>
        <Footer />
        <CustomModal
          className="max-w-[480px]"
          isOpen={showSignupModal}
          onClose={() => setShowSignupModal(false)}
        >
          <SignUpPopup />
        </CustomModal>
      </div>
    </>
  );
};

export default AcademicTutoring;
